export default {"src":"/_next/static/media/Icon_Dark_Mode.a8e9f1a5.svg","height":50,"width":40,"blurWidth":0,"blurHeight":0};